define.alias("ember-truth-helpers/helpers/lt", "calendar/helpers/lt");